const GAP = 24;
const AUTOPLAY_DELAY = 10000;
const PIXELS_PER_SECOND = 500;

let autoplayId = null;
let scrollIndex = 0;
let distanceToMove = 0;
let dynamicDuration = 0;
let totalMoveCount = 0;
let totalPCount = 0;

const handleTransitionEnd = (e) => {
	const sideCol = document.querySelector(".side-column");
	const containers = sideCol.querySelectorAll(
		".programs-container, .programs-container-clone",
	);

	if (scrollIndex >= totalMoveCount) {
		scrollIndex = 0;
		applyTransform(containers, false);
	}
};

const applyTransform = (containers, withTransition = true) => {
	const offset = distanceToMove * scrollIndex;
	containers.forEach((el) => {
		el.style.transition = withTransition
			? `transform ${dynamicDuration}ms ease-in-out`
			: "none";
		el.style.transform = `translateY(-${offset}px)`;
	});
};

const moveNext = () => {
	const sideCol = document.querySelector(".side-column");
	const containers = sideCol.querySelectorAll(
		".programs-container, .programs-container-clone",
	);
	scrollIndex++;
	applyTransform(containers, true);
};

const startAutoplay = () => {
	clearInterval(autoplayId);
	autoplayId = setInterval(moveNext, AUTOPLAY_DELAY);
};

const initVerticalScroll = (container, sideCol, cardHeight) => {
	if (!sideCol.dataset.carouselInitialized) {
		const clone = container.cloneNode(true);
		clone.classList.add("programs-container-clone");
		sideCol.appendChild(clone);
		sideCol.dataset.carouselInitialized = "true";
		sideCol.style.gap = `${GAP}px`;

		const firstContainer = sideCol.querySelector(".programs-container");
		firstContainer.addEventListener("transitionend", handleTransitionEnd);

		sideCol.onmouseenter = () => clearInterval(autoplayId);
		sideCol.onmouseleave = () => startAutoplay();
	}

	totalMoveCount =
		window.innerWidth > 768 ? Math.ceil(totalPCount / 2) : totalPCount;
	distanceToMove = cardHeight + GAP;
	dynamicDuration = (distanceToMove / PIXELS_PER_SECOND) * 1000;

	const containers = sideCol.querySelectorAll(
		".programs-container, .programs-container-clone",
	);

	scrollIndex = 0;
	applyTransform(containers, false);
	startAutoplay();
};

const adjustSideColumnHeight = () => {
	const globalContainer = document.querySelector(".home-programs-container");
	const mainCol = document.querySelector(".main-column");
	const sideCol = document.querySelector(".side-column");
	const firstContainer = sideCol?.querySelector(".programs-container");

	if (!globalContainer || !mainCol || !sideCol || !firstContainer) return;

	const cards = firstContainer.querySelectorAll(".program-card");

	// Reset for measurement
	cards.forEach((card) => (card.style.height = "auto"));

	let naturalRowHeight = 0;
	cards.forEach((card) => {
		if (card.offsetHeight > naturalRowHeight) {
			naturalRowHeight = card.offsetHeight;
		}
	});

	const baseSideHeight = naturalRowHeight * 2 + GAP;
	const mainHeight = mainCol.offsetHeight;
	let finalCardHeight = naturalRowHeight;

	if (window.innerWidth > 1024) {
		if (baseSideHeight < mainHeight) {
			finalCardHeight = (mainHeight - GAP) / 2;
			sideCol.style.height = `${mainHeight}px`;
		} else {
			sideCol.style.height = `${baseSideHeight}px`;
		}
	} else {
		sideCol.style.height = `${baseSideHeight}px`;
	}

	sideCol.querySelectorAll(".program-card").forEach((card) => {
		card.style.height = `${finalCardHeight}px`;
	});

	totalPCount = firstContainer.querySelectorAll(".program-card").length;

	if (totalPCount > 4) {
		initVerticalScroll(firstContainer, sideCol, finalCardHeight);
	}

	globalContainer.classList.remove("not-ready");
};

window.addEventListener("load", () => {
	adjustSideColumnHeight();
	let resizeTimer;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(adjustSideColumnHeight, 200);
	});
});
